module.exports = __webpack_public_path__ + "media/images/present-9322cbc3bb903b342743015c586b556c.svg";